import { render, staticRenderFns } from "./BCKeyAssignmentExtendedMenu.vue?vue&type=template&id=474ed358"
import script from "./BCKeyAssignmentExtendedMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BCKeyAssignmentExtendedMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports